import { FaFacebook, FaTwitter, FaInstagram, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import AnimatedSection from "./AnimatedSection";
import { useTranslation } from "react-i18next";
import "../i18n"; // Import i18n setup

const Footer = () => {
  const { t } = useTranslation(['common', 'footer']);

  return (
    <AnimatedSection>
      <footer className="bg-white text-black p-6 md:p-10">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          {/* Company Name & Social Media */}
          <div>
            <h2 className="text-xl">{t("common:decimicInc")}</h2>
            <p className="mt-4">{t("footer:slogan")}</p>
            <div className="flex justify-center md:justify-start gap-4 mt-4">
              <a
                href="https://www.facebook.com/profile.php?id=61575337568628"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <FaFacebook className="text-2xl cursor-pointer hover:text-blue-500" />
              </a>
              {/* <FaTwitter className="text-2xl cursor-pointer hover:text-blue-400" />
              <FaInstagram className="text-2xl cursor-pointer hover:text-pink-500" /> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="text-xl">{t("footer:quickLinks")}</h2>
            <ul className="mt-4 space-y-2">
              <li><a href="/about/message" className="hover:text-gray-400">{t('footer:ql.pcm')}</a></li>
              <li><a href="/about/corporatephilosophy" className="hover:text-gray-400">{t('footer:ql.cp')}</a></li>
              {/* <li><a href="/managementpolicy" className="hover:text-gray-400">Management Policy</a></li> */}
            </ul>
          </div>

          {/* Address */}
          <div>
            <h2 className="text-xl">{t("common:contactUs")}</h2>
            <div className="mt-4 space-y-2">
              <p className="flex items-center justify-center md:justify-start">
                <FaMapMarkerAlt className="mr-2 text-xl" /> {t("common:address")}
              </p>
              <p className="flex items-center justify-center md:justify-start">
                <FaPhoneAlt className="mr-2 text-xl" />
                {t("common:phoneNumber")}
              </p>
              <p className="flex items-center justify-center md:justify-start">
                <FaEnvelope className="mr-2 text-xl" />
                <a
                  href={`mailto:${t("common:contactEmail")}`}
                  className="text-blue-600 hover:underline"
                >
                  {t("common:contactEmail")}
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-gray-700 mt-6 pt-4 flex flex-col md:flex-row justify-between items-center">
          <p>© Decimic, All Rights Reserved. Designed By Decimic Inc.</p>

          {/* New Links */}
          <div className="flex space-x-6 mt-2 md:mt-0">
            <a href="/privacypolicy" className="hover:text-gray-400">{t("footer:footerLink.privacyPolicy")}</a>
            <a href="/termscondition" className="hover:text-gray-400">{t("footer:footerLink.termsCondition")}</a>
            {/* <a href="/sitemap" className="hover:text-gray-400">Site Map</a> */}
          </div>
        </div>
      </footer>
    </AnimatedSection>
  );
};

export default Footer;